module.exports = __webpack_public_path__ + "static/img/5-g.104deeba.png";